import axios, { AxiosResponse } from "axios";

import { actionTypes } from "../types/folderTypes";
import { actionTypes as notificationAction } from "../types/notificationTypes";
import { AppThunkAction } from "./../store/index";
import {
    IFolderModel,
    IFolderPermissionViewModel,
    IMyFilesDownloadPayload,
    ISharedFolderGroupPermissionDetailViewModel,
    ISharedFolderPermissionDetailViewModel,
    ISharedFolderUserModel,
} from "../Core/ViewModels/Folder/FolderModel";
import { NotificationAction, StatusType } from "../store/Common/NotificationStore";
import { ArchiveFolderType, DownloadedFrom, FolderColumnName, MessageSource, SortOrder } from "../Core/Common/Enums";
import { getMailboxUserEmailId } from "../helper/HelperFunctions";
import {
    AddMovingFolders,
    CompletedAddNewFolderAction,
    CompletedCheckFolderMessagesAction,
    CompletedDeleteFolder,
    CompletedDeleteFolders,
    CompletedFoldersAction,
    CompletedFoldersTreeAction,
    CompletedMoveFolders,
    CompletedRetentionPeriodsAction,
    CompletedSubFoldersAction,
    CompletedUpdateFolderExpiry,
    CompletedUpdateFolderName,
    CompletedUpdateFoldersExpiry,
    ReceivedFoldersAction,
    ReceivedFoldersTreeAction,
    ReceivedRetentionPeriodsAction,
    ReceivedSubFoldersAction,
    ReceiveUpdateFolderName,
    RemoveMovingFolders,
    RequestAddNewFolderAction,
    RequestCheckFolderMessagesAction,
    RequestDeleteFolder,
    RequestDeleteFolders,
    RequestFoldersAction,
    RequestFoldersTreeAction,
    RequestMoveFolders,
    RequestRetentionPeriodsAction,
    RequestSubFoldersAction,
    RequestUpdateFolderExpiry,
    RequestUpdateFolderName,
    RequestUpdateFoldersExpiry,
    RequestFolderIsExistAction,
    ReceiveFolderIsExistAction,
    CompleteFolderIsExistAction,
    RequestFolderDetailAction,
    ReceiveFolderDetailAction,
    CompleteFolderDetailAction,
    RequestFolderDetailsWithPermissionAction,
    ReceiveFolderDetailsWithPermissionAction,
    CompleteFolderDetailsWithPermissionAction,
    RequestShareFolderAction,
    ReceiveShareFolderAction,
    CompleteShareFolderAction,
    RequestFolderMaxRetentionAction,
    ReceivedFolderMaxRetentionAction,
    CompletedFolderMaxRetentionAction,
    ReceivedUserOwnedFoldersAction,
    RequestFolderDropOffLinkAction,
    ReceiveFolderDropOffLinkAction,
    CompleteFolderDropOffLinkAction,
    RequestUsersToShareFolderAction,
    ReceivedUsersToShareFolderAction,
    CompletedUsersToShareFolderAction,
    RequestMessageFileViewData,
    ReceiveMessageFileViewData,
    CompletedMessageFileViewData,
    RequestDownloadNow,
    ReceiveDownloadNow,
    CompleteDownloadNow,
} from "src/actions/folderActions";
import { IRetentionPeriod } from "../../src/Core/ViewModels/Company/Settings/RetentionSettings";
import { AppNotifier } from "../../src/components/Common/Notification/AppNotifier";
import { logger } from "../../src/routes/LoggedIn";
import { appInsightsData } from "../../src/helper/AppInsightsData";
import { IMyFilesFileModel } from "src/Core/ViewModels/File/MyFilesFileModel";
import { ToasterMessages } from "src/helper/ToasterMessages";
import moment from "moment";
import { ReportDownloadContansts } from "src/Core/Common/Constants";
import fileDownload from "js-file-download";

export type DispatchActions =
    | RequestFoldersAction
    | ReceivedFoldersAction
    | CompletedFoldersAction
    | RequestFoldersTreeAction
    | ReceivedFoldersTreeAction
    | CompletedFoldersTreeAction
    | RequestRetentionPeriodsAction
    | ReceivedRetentionPeriodsAction
    | CompletedRetentionPeriodsAction
    | RequestUpdateFolderExpiry
    | CompletedUpdateFolderExpiry
    | RequestAddNewFolderAction
    | CompletedAddNewFolderAction
    | RequestDeleteFolder
    | CompletedDeleteFolder
    | RequestSubFoldersAction
    | ReceivedSubFoldersAction
    | CompletedSubFoldersAction
    | RequestDeleteFolders
    | CompletedDeleteFolders
    | RequestUpdateFoldersExpiry
    | CompletedUpdateFoldersExpiry
    | RequestMoveFolders
    | CompletedMoveFolders
    | RequestCheckFolderMessagesAction
    | CompletedCheckFolderMessagesAction
    | RequestUpdateFolderName
    | CompletedUpdateFolderName
    | ReceiveUpdateFolderName
    | AddMovingFolders
    | RemoveMovingFolders
    | RequestFolderIsExistAction
    | ReceiveFolderIsExistAction
    | CompleteFolderIsExistAction
    | RequestFolderDetailAction
    | ReceiveFolderDetailAction
    | CompleteFolderDetailAction
    | RequestFolderDetailsWithPermissionAction
    | ReceiveFolderDetailsWithPermissionAction
    | CompleteFolderDetailsWithPermissionAction
    | RequestShareFolderAction
    | ReceiveShareFolderAction
    | CompleteShareFolderAction
    | RequestFolderMaxRetentionAction
    | ReceivedFolderMaxRetentionAction
    | CompletedFolderMaxRetentionAction
    | ReceivedUserOwnedFoldersAction
    | RequestFolderDropOffLinkAction
    | ReceiveFolderDropOffLinkAction
    | CompleteFolderDropOffLinkAction
    | RequestUsersToShareFolderAction
    | ReceivedUsersToShareFolderAction
    | CompletedUsersToShareFolderAction
    | RequestMessageFileViewData
    | ReceiveMessageFileViewData
    | CompletedMessageFileViewData
    | RequestDownloadNow
    | ReceiveDownloadNow
    | CompleteDownloadNow;

type AllKnownActions = DispatchActions | NotificationAction;

export const fetchFolders =
    (folderTypes: ArchiveFolderType[], callback?: (data: IFolderModel[]) => void): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_FOLDERS,
            });
            axios
                .get(
                    `${process.env.REACT_APP_API_URL}/api/Folder/GetFolders?mailboxUserEmailId=${getMailboxUserEmailId()}`,
                    {
                        params: { folderTypes },
                    }
                )
                .then(response => {
                    const data = response.data;
                    dispatch({
                        type: actionTypes.RECEIVED_FOLDERS,
                        folders: data,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                    dispatch({
                        type: actionTypes.COMPLETED_FOLDERS,
                    });
                });
        };

export const fetchFoldersTree =
    (
        folderTypes: ArchiveFolderType[],
        folderIds: number[],
        callback?: (data: IFolderModel[]) => void
    ): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_FOLDERS_TREE,
            });
            axios
                .get(
                    `${process.env.REACT_APP_API_URL
                    }/api/Folder/GetFoldersTree?mailboxUserEmailId=${getMailboxUserEmailId()}`,
                    {
                        params: {
                            folderTypes,
                            folderIds,
                        },
                    }
                )
                .then((response: AxiosResponse) => {
                    const data = response.data;
                    dispatch({
                        type: actionTypes.RECEIVED_FOLDERS_TREE,
                        folders: data,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETED_FOLDERS_TREE,
                    });
                });
        };

export const fetchSubFolders =
    (
        folderId: number,
        sortColumn: FolderColumnName,
        sortOrder: SortOrder,
        callback?: (data: IFolderModel[]) => void,
        searchText = ""
    ): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_SUB_FOLDERS,
                folderId: folderId,
            });
            searchText = searchText.trim();
            axios
                .get(
                    `${process.env.REACT_APP_API_URL
                    }/api/Folder/GetSubFolders?mailboxUserEmailId=${getMailboxUserEmailId()}&parentFolderId=${folderId}&sortColumn=${sortColumn}&sortOrder=${sortOrder}&searchText=${encodeURIComponent(
                        searchText
                    )}`
                )
                .then(response => {
                    const data = response.data;
                    dispatch({
                        type: actionTypes.RECEIVED_SUB_FOLDERS,
                        folders: data,
                        folderId: folderId,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETED_SUB_FOLDERS,
                        folderId: folderId,
                    });
                });
        };

export const fetchRetentionPeriods =
    (callback?: (data: IRetentionPeriod[]) => void): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_RETENTION_PERIODS,
            });
            axios
                .get(`${process.env.REACT_APP_API_URL}/api/Folder/GetRetentionPeriodList`)
                .then(response => {
                    const data = response.data;

                    dispatch({
                        type: actionTypes.RECEIVED_RETENTION_PERIODS,
                        data: data,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                    dispatch({
                        type: actionTypes.COMPLETED_FOLDERS,
                    });
                });
        };

export const updateFoldersRetentionPeriod =
    (
        folderIds: number[],
        expiresDays: number,
        callback?: (result: number) => void,
        resourceId?: string
    ): AppThunkAction<AllKnownActions> =>
        dispatch => {
            const mailboxUserEmailId = getMailboxUserEmailId();
            dispatch({
                type: actionTypes.REQUEST_UPDATE_FOLDERS_EXPIRY,
            });
            axios
                .put(`${process.env.REACT_APP_API_URL}/api/Folder/UpdateFoldersRetention`, folderIds, {
                    params: {
                        expiresDays,
                        mailboxUserEmailId,
                    },
                    headers: {
                        "X-Resource-Id": resourceId ?? "",
                    },
                })
                .then(response => {
                    const data = response.data;

                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() =>
                    dispatch({
                        type: actionTypes.COMPLETED_UPDATE_FOLDERS_EXPIRY,
                        folderIds: folderIds,
                        result: true,
                        expiresDays: expiresDays,
                    })
                );
        };

export const updateFolderName =
    (folder: IFolderModel, resourceId?: string, callback?: (result: number) => void): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_UPDATE_FOLDER_NAME,
            });
            axios
                .put(
                    `${process.env.REACT_APP_API_URL
                    }/api/Folder/UpdateFolder?mailboxUserEmailId=${getMailboxUserEmailId()}`,
                    folder,
                    {
                        headers: {
                            "X-Resource-Id": resourceId ?? "",
                        },
                    }
                )
                .then(response => {
                    const data = response.data;

                    dispatch({
                        type: actionTypes.RECEIVE_UPDATE_FOLDER_NAME,
                        payload: folder,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.response.data.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() =>
                    dispatch({
                        type: actionTypes.COMPLETED_UPDATE_FOLDER_NAME,
                    })
                );
        };

export const addNewFolder =
    (folder: IFolderModel, callback?: (result: IFolderModel) => void): AppThunkAction<AllKnownActions> =>
        dispatch => {
            const mailboxUserEmailId = getMailboxUserEmailId();
            dispatch({
                type: actionTypes.REQUEST_ADD_NEW_FOLDER,
            });
            axios
                .post(`${process.env.REACT_APP_API_URL}/api/Folder/AddNewFolder`, folder, {
                    params: { mailboxUserEmailId },
                })
                .then(response => {
                    const data = response.data;
                    folder.folderId = data;
                    if (callback) {
                        callback(folder);
                    }
                })
                .catch(error => {
                    AppNotifier.Error(error.response.data.message);
                })
                .finally(() =>
                    dispatch({
                        type: actionTypes.COMPLETED_ADD_NEW_FOLDER,
                        folder: folder,
                    })
                );
        };

export const deleteFolders =
    (folderIds: number[], callback: (result: boolean) => void, resourceId?: string): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_DELETE_FOLDERS,
            });
            logger.trackEvent({
                name: `${appInsightsData.Folders.MyFiles.PageTitle} - ${appInsightsData.Folders.MyFiles.Operations.DeleteFolder}`,
                properties: {
                    page: appInsightsData.Folders.MyFiles.PageTitle,
                    folderIds,
                },
            });
            axios
                .delete(
                    `${process.env.REACT_APP_API_URL
                    }/api/Folder/DeleteFolders?mailboxUserEmailId=${getMailboxUserEmailId()}`,
                    {
                        data: folderIds,
                        headers: {
                            "X-Resource-Id": resourceId ?? "",
                        },
                    }
                )
                .then(() => {
                    if (callback) {
                        callback(true);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() =>
                    dispatch({
                        type: actionTypes.COMPLETED_DELETE_FOLDERS,
                        folderIds: folderIds,
                        result: true,
                    })
                );
        };

export const moveFolders =
    (
        folderIds: number[],
        sourceFolders: IFolderModel[],
        destinationFolder: IFolderModel,
        callback?: (result: boolean) => void,
        resourceId?: string
    ): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_MOVE_FOLDERS,
            });

            axios
                .put(
                    `${process.env.REACT_APP_API_URL}/api/Folder/MoveFolders?mailboxUserEmailId=${getMailboxUserEmailId()}`,
                    {
                        destinationFolderModel: destinationFolder,
                        sourceFolders: sourceFolders,
                    },
                    {
                        headers: {
                            "X-Resource-Id": resourceId ?? "",
                        },
                    }
                )
                .then(() => {
                    if (callback) {
                        callback(true);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.response.data.message,
                        statusType: StatusType.Error,
                    });
                    if (callback) {
                        callback(false);
                    }
                })
                .finally(() =>
                    dispatch({
                        type: actionTypes.COMPLETED_MOVE_FOLDERS,
                        folderIds: folderIds,
                        result: true,
                    })
                );
        };

export const isFolderExist =
    (folderId: number, callback?: (result: boolean) => void): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_FOLDER_IS_EXIST,
            });
            axios
                .get(
                    `${process.env.REACT_APP_API_URL
                    }/api/Folder/IsFolderExist/${folderId}?mailboxUserEmailId=${getMailboxUserEmailId()}`
                )
                .then((response: any) => {
                    const data = response.data;
                    dispatch({
                        type: actionTypes.RECEIVE_FOLDER_IS_EXIST,
                        isExist: data,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETE_FOLDER_IS_EXIST,
                    });
                });
        };

export const fetchFolderDetail =
    (folderId: number, callback?: (data: IFolderModel) => void): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_FOLDER_DETAIL,
            });
            axios
                .get(`${process.env.REACT_APP_API_URL}/api/Folder/GetFolderDetail/${folderId}`)
                .then((response: any) => {
                    const data = response.data;
                    dispatch({
                        type: actionTypes.RECEIVE_FOLDER_DETAIL,
                        data: data,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETE_FOLDER_DETAIL,
                    });
                });
        };

export const fetchFolderDetailsWithPermission =
    (folderId: number, callback?: (data: IFolderModel) => void): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_FOLDER_DETAILS_WITH_PERMISSION,
            });
            axios
                .get(`${process.env.REACT_APP_API_URL}/api/Folder/GetFolderDetailsWithPermission/${folderId}`)
                .then((response: any) => {
                    const data = response.data;
                    dispatch({
                        type: actionTypes.RECEIVE_FOLDER_DETAILS_WITH_PERMISSION,
                        data: data,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETE_FOLDER_DETAILS_WITH_PERMISSION,
                    });
                });
        };

//#region Shared Folder

export const fetchSharedFolderUsers =
    (
        folderId: number,
        callback?: (data: {
            users: ISharedFolderPermissionDetailViewModel[];
            groups: ISharedFolderGroupPermissionDetailViewModel[];
        }) => void
    ): AppThunkAction<AllKnownActions> =>
        dispatch => {
            const mailboxUserEmailId = getMailboxUserEmailId();
            dispatch({
                type: actionTypes.REQUEST_SHARE_FOLDER,
            });
            axios
                .get(
                    `${process.env.REACT_APP_API_URL}/api/SharedFolder/GetAllUserOfSharedFolder?mailboxUserEmailId=${mailboxUserEmailId}&folderId=${folderId}`
                )
                .then((response: any) => {
                    const data = response.data;
                    dispatch({
                        type: actionTypes.RECEIVE_SHARE_FOLDER,
                        sharedUsersData: data,
                    });

                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.response.data.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETE_SHARE_FOLDER,
                    });
                });
        };

export const shareFolderToUsers =
    (folderShareInformation: IFolderPermissionViewModel, callback?: any): AppThunkAction<AllKnownActions> =>
        dispatch => {
            const mailboxUserEmailId = getMailboxUserEmailId();
            logger.trackEvent({
                name: `${appInsightsData.Folders.MyFiles.PageTitle} - ${appInsightsData.Folders.MyFiles.Operations.ShareFolder}`,
                properties: {
                    page: appInsightsData.Folders.MyFiles.PageTitle,
                    folderShareInformation,
                },
            });
            dispatch({
                type: actionTypes.REQUEST_SHARE_FOLDER,
            });

            axios
                .post(`${process.env.REACT_APP_API_URL}/api/SharedFolder/AddFolderPermission`, folderShareInformation, {
                    params: { mailboxUserEmailId },
                })
                .then((response: any) => {
                    const data = response.data;
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.response.data.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETE_SHARE_FOLDER,
                    });
                });
        };

export const updateSharedFolderUsers =
    (
        folderShareInformation: IFolderPermissionViewModel,
        callback?: (status: number) => void
    ): AppThunkAction<AllKnownActions> =>
        dispatch => {
            const mailboxUserEmailId = getMailboxUserEmailId();
            logger.trackEvent({
                name: `${appInsightsData.Folders.MyFiles.PageTitle} - ${appInsightsData.Folders.MyFiles.Operations.UpdateSharedFolderUserPermission}`,
                properties: {
                    page: appInsightsData.Folders.MyFiles.PageTitle,
                    folderShareInformation,
                },
            });
            dispatch({
                type: actionTypes.REQUEST_ADD_NEW_FOLDER,
            });

            axios
                .put(`${process.env.REACT_APP_API_URL}/api/SharedFolder/UpdateFolderPermission`, folderShareInformation, {
                    params: { mailboxUserEmailId },
                })
                .then((response: AxiosResponse) => {
                    const data = response;

                    if (callback) {
                        callback(data.status);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.response.data.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETE_SHARE_FOLDER,
                    });
                });
        };

export const removeSharedFolderUsers =
    (
        folderShareInformation: IFolderPermissionViewModel,
        callback?: (status: number) => void
    ): AppThunkAction<AllKnownActions> =>
        dispatch => {
            logger.trackEvent({
                name: `${appInsightsData.Folders.MyFiles.PageTitle} - ${appInsightsData.Folders.MyFiles.Operations.RemoveSharedFolderUser}`,
                properties: {
                    page: appInsightsData.Folders.MyFiles.PageTitle,
                    folderShareInformation,
                },
            });
            dispatch({
                type: actionTypes.REQUEST_SHARE_FOLDER,
            });

            axios
                .delete(`${process.env.REACT_APP_API_URL}/api/SharedFolder/DeleteFolderPermission`, {
                    params: { mailboxUserEmailId: getMailboxUserEmailId() },
                    data: folderShareInformation,
                })
                .then((response: AxiosResponse) => {
                    const data = response;
                    if (callback) {
                        callback(data.status);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.response.data.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETE_SHARE_FOLDER,
                    });
                });
        };

export const fetchShareFolderRecipients =
    (
        searchString: string,
        folderId: number,
        callback?: (data: ISharedFolderUserModel[]) => void
    ): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_USERS_TO_SHARE,
            });
            const mailboxUserEmailId = getMailboxUserEmailId();

            axios
                .get(
                    `${process.env.REACT_APP_API_URL
                    }/api/SharedFolder/GetUsers?mailboxUserEmailId=${mailboxUserEmailId}&folderId=${folderId}&searchString=${searchString.trim()}`
                )
                .then(response => {
                    const data = response.data;
                    dispatch({
                        type: actionTypes.RECEIVE_USERS_TO_SHARE,
                        data: data,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: actionTypes.COMPLETE_USERS_TO_SHARE,
                    });
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                });
        };

//#endregion Shared Folder

export const fetchMaxRetentionPeriodLimit =
    (folderId: number, callback?: (result: number) => void): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_FOLDER_MAX_RETENTION,
                folderId: folderId,
            });
            axios
                .get(`${process.env.REACT_APP_API_URL}/api/Folder/MaxRetentionPeriodLimit/${folderId}`)
                .then((response: any) => {
                    const data = response.data;
                    dispatch({
                        type: actionTypes.RECEIVE_FOLDER_MAX_RETENTION,
                        maxRetention: data,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETE_FOLDER_MAX_RETENTION,
                    });
                });
        };

export const fetchUserOwnedFolders =
    (callback?: any): AppThunkAction<AllKnownActions> =>
        dispatch => {
            axios
                .get(
                    `${process.env.REACT_APP_API_URL
                    }/api/Folder/GetUserOwnedFolders?mailboxUserEmailId=${getMailboxUserEmailId()}`
                )
                .then((response: any) => {
                    const data = response.data;
                    dispatch({
                        type: actionTypes.RECEIVE_USEROWNED_FOLDERS,
                        data,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                });
        };

export const fetchFolderDropOffLink =
    (folderId: number, callback?: (result: string) => void): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_FOLDER_DROPOFF_LINK,
            });
            axios
                .get(`${process.env.REACT_APP_API_URL}/api/Folder/DropOffLink/${folderId}`)
                .then((response: any) => {
                    const data = response.data;
                    dispatch({
                        type: actionTypes.RECEIVE_FOLDER_DROPOFF_LINK,
                        dropOffUrl: data,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETE_FOLDER_DROPOFF_LINK,
                    });
                });
        };

export const updateFolderNotifications =
    (folderId: number, notificationState: boolean, callback?: any): AppThunkAction<AllKnownActions> =>
        dispatch => {
            logger.trackEvent({
                name: `${appInsightsData.Folders.MyFiles.PageTitle} - ${appInsightsData.Folders.MyFiles.Operations.UpdateFolderNotifications}`,
                properties: {
                    page: appInsightsData.Folders.MyFiles.PageTitle,
                    folderId: folderId,
                    notificationState: notificationState,
                },
            });
            axios
                .put(
                    `${process.env.REACT_APP_API_URL
                    }/api/Folder/UpdateFolderNotification?mailboxUserEmailId=${getMailboxUserEmailId()}&folderId=${folderId}&notificationState=${notificationState}`
                )
                .then((response: any) => {
                    const data = response.data;
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.response.data.message,
                        statusType: StatusType.Error,
                    });
                });
        };

export const fetchFolderFileViewData =
    (
        folderId: number,
        pageNo: number,
        pageSize: number,
        mailboxUserEmailId: string,
        searchText?: string,
        sortColumn?: string,
        sortOrder?: string,
        callback?: (data: IMyFilesFileModel[]) => void
    ): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({
                type: actionTypes.REQUEST_FILE_VIEW_DATA,
            });
            axios
                .get(`${process.env.REACT_APP_API_URL}/api/Folder/FolderFiles`, {
                    params: {
                        folderId,
                        pageNo,
                        pageSize,
                        mailboxUserEmailId,
                        searchText,
                        sortColumn,
                        sortOrder,
                        requestApp: MessageSource.WEBADDIN
                    },
                })
                .then((response: AxiosResponse) => {
                    const data = response.data;

                    dispatch({
                        type: actionTypes.RECEIVE_FILE_VIEW_DATA,
                        payload: data,
                    });
                    if (callback) {
                        callback(data);
                    }
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETED_FILE_VIEW_DATA,
                    });
                });
        };


export const requestDownloadNow =
    (payload: IMyFilesDownloadPayload, callback: () => void, resourceId?: string): AppThunkAction<AllKnownActions> =>
        dispatch => {
            dispatch({ type: actionTypes.REQUEST_DOWNLOAD_NOW });
            AppNotifier.Warning(ToasterMessages.WARNING.DOWNLOAD_PROGRESS);
            const date = moment().format(ReportDownloadContansts.DATE_FORMAT_FILE_NAME);
            const filename = `${ReportDownloadContansts.MY_FILES_ZIP_NAME}${date}`;
            axios
                .post(
                    `${process.env.REACT_APP_API_URL
                    }/api/Download/Files/Multiple?mailboxUserEmailId=${getMailboxUserEmailId()}&downloadedFrom=${DownloadedFrom.MPI_Download_Archive_Multiple_File
                    }&friendlyFileNameForZip=${filename}`,
                    payload,
                    {
                        responseType: "blob",
                        headers: {
                            "X-Resource-Id": resourceId ?? "",
                        },
                    }
                )
                .then((response: AxiosResponse) => {
                    dispatch({ type: actionTypes.RECEIVE_DOWNLOAD_NOW });
                    const data = response.data;
                    const fileExtension = "zip";
                    fileDownload(data, `${filename}.${fileExtension}`);
                    callback();
                })
                .catch(error => {
                    dispatch({
                        type: notificationAction.NOTIFICATION,
                        statusMessage: error.message,
                        statusType: StatusType.Error,
                    });
                })
                .finally(() => {
                    dispatch({
                        type: actionTypes.COMPLETE_DOWNLOAD_NOW,
                    });
                });
        };

